<groupui-card background="white">
  <h3>{{ 'dashboard.version-status.' + versionType + '-title' | translate }}</h3>
  <div class="version-container">
    {{currentVersion | placeholder}}
  </div>
</groupui-card>
